import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProviderWrapper } from "./theme/ThemeProvider";
import { RegistryProvider } from "./context/RegistryContext";
import { Layout } from "./components/Layout";
import { AddTransactionPage } from "./pages/AddTransactionPage";
import { TransactionListPage } from "./pages/TransactionListPage";
import { TransactionDetailsPage } from "./pages/TransactionDetailsPage";
import { MonthlySummaryPage } from "./pages/MonthlySummaryPage";
import { SourcesPage } from "./pages/Settings/SourcesPage";
import { GroupsPage } from "./pages/Settings/GroupsPage";
import { CategoriesPage } from "./pages/Settings/CategoriesPage";
import { ExpenseTypesPage } from "./pages/Settings/ExpenseTypesPage";
import { PayeesPage } from "./pages/Settings/PayeesPage";
import { InvoicesPage } from "./pages/Admin/InvoicesPage";
import { AutoTransactionsPage } from "./pages/Admin/AutoTransactionsPage";
import { LibraryPage } from "./pages/Admin/LibraryPage";
import { AutoTransactionForm } from "./pages/Settings/AutoTransactionForm";
import { AdminPage, AdminIndexRedirect } from "./pages/Admin/AdminPage";
import { AdminDashboard } from "./pages/Admin/AdminDashboard";
import { DebugConsole } from "./pages/Admin/DebugConsole";
import { ImportsPage } from "./pages/Admin/ImportsPage";
import { AttachmentsPage } from "./pages/Admin/AttachmentsPage";
import { LLMChat } from "./pages/Admin/LLMChat";
import { HomePage } from "./pages/Home";
import { GemmaProvider } from "./ai/gemma";
import { NotFoundPage } from "./pages/NotFoundPage";
import "./App.css";

function App() {
  return (
    <ThemeProviderWrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/cdn-cgi/*" element={<NotFoundPage />} />
          <Route
            path="/"
            element={
              <RegistryProvider>
                <GemmaProvider>
                  <Layout />
                </GemmaProvider>
              </RegistryProvider>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="home" element={<HomePage />} />
            <Route path="add" element={<AddTransactionPage />} />
            <Route path="transactions" element={<TransactionListPage />} />
            <Route
              path="transactions/:id"
              element={<TransactionDetailsPage />}
            />
            <Route path="summary" element={<MonthlySummaryPage />} />
            <Route path="admin" element={<AdminPage />}>
              <Route index element={<AdminIndexRedirect />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="sources" element={<SourcesPage />} />
              <Route path="payees" element={<PayeesPage />} />
              <Route path="groups" element={<GroupsPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="expense-types" element={<ExpenseTypesPage />} />
              <Route path="invoices" element={<InvoicesPage />} />
              <Route
                path="auto-transactions"
                element={<AutoTransactionsPage />}
              />
              <Route
                path="auto-transactions/new"
                element={<AutoTransactionForm />}
              />
              <Route
                path="auto-transactions/:id"
                element={<AutoTransactionForm />}
              />
              <Route path="library" element={<LibraryPage />} />
              <Route path="debug" element={<DebugConsole />} />
              <Route path="imports" element={<ImportsPage />} />
              <Route path="attachments" element={<AttachmentsPage />} />
              <Route path="llm-chat" element={<LLMChat />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProviderWrapper>
  );
}

export default App;
